import Vue from 'vue'
import appConfig from "@src/app.config.json";
import VueAnalytics from "vue-analytics";
import router from "@router/index";

const AppGa = appConfig.ga;
const MerchantGa = window.globalData.ga;

Vue.use(VueAnalytics, {
  id: ['UA-186436523-1', AppGa, MerchantGa],
  disableScriptLoader: true,
  router,
  autoTracking: {
    pageviewOnLoad: false,
  },
});
